/* eslint-disable no-unused-vars */
import React, { useContext } from 'react'
import Link from 'next/link'
import { FormContext } from '../../../../pages/_app'
import { parseHtml } from '../../../../utils/common'
import dynamic from "next/dynamic";

const HocButton = dynamic(() => import('../../../HigherOrderComponent/HocButton'))

function ServiceBanner(props) {
  const { showForm } = useContext(FormContext)
  let block = props.block
  let ctaButton = block.button.length > 0 ? block.button[0] : block.button
  return (
    <>
      <section className="agile-banner-section">
        <div className="agile-banner-inner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="agile-banner-content">
                  <div className="heading">
                    { block.short_title && 
						<h3>{block.short_title}</h3>
					}
                    <h1 className='page-heading'>{block.title}</h1>
                    {block.description
                      ? parseHtml(block.description, true)
                      : ''}
                  </div>
                  <HocButton button={ctaButton} btnAction={() => showForm()}>
                    <Link
                      href={'/request-proposal'}
                      className="btn btn-primary"
                    >
                      {ctaButton.label}
                    </Link>
                  </HocButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ServiceBanner
